export default __webpack_public_path__ + "static/media/integrated-quiz.b286c3b8.gif";